// extracted by mini-css-extract-plugin
export default {"dataDisplay":"QuizzesPage_dataDisplay__2TQRD","value":"QuizzesPage_value__oZ9Uq","subText":"QuizzesPage_subText__KM79P"};